import wordingModules from 'src/store/modules/wording'
import generalModules from 'src/store/general'
import tables from './tables'

const { lang } = generalModules.state()
const wording = wordingModules.state

function generateSteps (prop) {
  const mappedStatus = []
  const status = wording[lang][prop]

  for (const prop in status) {
    // Omit `CANCELED` status from all steps
    // to prevent render it in Stepper component
    if (prop === 'CANCELED') continue

    mappedStatus.push({
      label: status[prop],
      value: prop
    })
  }

  return mappedStatus
}

export default function () {
  return {
    // SO_TRANSFER | SO_TERMIN | PO_CBD | PO_REST | DO_CBD | DO_REST
    type: 'SO_TRANSFER',

    // Based on the steps value below
    status: 'PROCESSED',
    statusPayment: 'UNPAID',

    allSteps: {
      SO: generateSteps('soStatus'),
      PO: generateSteps('poStatus'),
      DO: generateSteps('doStatus')
    },

    stepsOrder: {
      SO: {
        TRANSFER: ['UNPAID', 'PAID', 'PROCESSED', 'SENT', 'FINISHED'],
        TERMIN: ['PROCESSED', 'SENT', 'UNPAID', 'PAID', 'FINISHED']
      },
      PO: {
        CBD: ['UNAPPROVED', 'PAID', 'PROCESSED', 'PARTIALLY_DELIVERED', 'DELIVERED'],
        REST: ['UNAPPROVED', 'PROCESSED', 'PARTIALLY_DELIVERED', 'DELIVERED', 'PAID']
      },
      DO: {
        CBD: ['PROCESSED', 'SCHEDULED', 'SENT', 'RETURN_LETTER', 'FINISHED'],
        REST: ['PROCESSED', 'SCHEDULED', 'SENT', 'RETURN_LETTER', 'FINISHED']
      }
    },

    tables
  }
}
